import React, { useState } from "react";
import { Table, Modal, Button } from "antd";
import { DownloadOutlined } from "@ant-design/icons";
import { useGetBillingHistory } from "../hooks/useGetBillingHistory";
import CurrencyFormatter from "utils/CurrencyFormatter";
import dayjs from "dayjs";
import { TransactionReceipt } from "./Transaction";

interface DataType {
  key: string;
  name: string;
  date: string;
  amount: number;
  plan: string;
  action: any;
}

export const BillingHistory = () => {
  const { data, isLoading } = useGetBillingHistory();


  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedTransaction, setSelectedTransaction] = useState<any>(null);


  const handleOpenModal = (transaction: any) => {
    setSelectedTransaction(transaction);
    setIsModalVisible(true);
  };


  const handleCloseModal = () => {
    setIsModalVisible(false);
    setSelectedTransaction(null);
  };

  const columns = [
    {
      title: "TRX Ref",
      dataIndex: "trans_ref",
      key: "trans_ref"
    },
    {
      title: "Billing date",
      dataIndex: "created_at",
      key: "created_at",
      render: (text: any) => <>{dayjs(text).format('DD/MM/YYYY')}</>,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text: any) => <CurrencyFormatter value={Number(text)} decimalPrecision={0} />,
    },
    {
      title: "Plan",
      dataIndex: "",
      key: "package",
      render: (text: any) => <>{text?.package.name} ({text?.plan_duration})</>
    },
    {
      title: "",
      dataIndex: "action",
      key: "action",
      render: (text: any, record: any) => (
        <a
          onClick={() => handleOpenModal(record)}
          className="capitalize text-primary font-medium"
        >
          {text || "View Details"}
        </a>
      ),
    },
  ];

  return (
    <div className="bg-white border rounded-md mt-12 px-3 py-5">
      <div className="flex justify-between items-center mb-3">
        <h4 className="font-medium text-lg text-primary">Billing History</h4>
        {/* <button className="button flex items-center gap-2"> */}
        {/*   <i className="ri-download-line"></i> <span>Download all</span> */}
        {/* </button> */}
      </div>

      {/* Table with the data */}
      <Table
        scroll={{ x: 500 }}
        columns={columns}
        dataSource={data}
      />

      {/* Transaction Receipt Modal */}
      <Modal
        title="Transaction Details"
        open={isModalVisible}
        onCancel={handleCloseModal}
        footer={[
          <Button key="close" onClick={handleCloseModal}>
            Close
          </Button>,
        ]}
        width="40%"
        styles={{
          body: {
            maxHeight: "70vh", overflowY: "auto"
          },
        }}

      >

        {selectedTransaction && (
          <TransactionReceipt transaction={selectedTransaction} />
        )}
      </Modal>
    </div>
  );
};
